import options from './md-custom-column.directive';

export default {
    selector: 'mdCustomColumn',
    options
};
